/* TrendDrop — key features: open the matching tab when a block is selected in the theme editor. */
(() => {
  if (window.__tdKeyFeaturesInit) return;
  window.__tdKeyFeaturesInit = true;
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest?.('.td-kf__tab') ||
      document.querySelector(`.td-kf__tab[data-block-id="${event.detail?.blockId}"]`);
    if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
  });
})();
